import { request as getBonuses } from './reducers/query-bonuses';

// eslint-disable-next-line import/no-default-export
export default {
    BONUSES_REQUEST: getBonuses,
};
